import { render, staticRenderFns } from "./PostSlim.vue?vue&type=template&id=3ec19af9&"
import script from "./PostSlim.vue?vue&type=script&lang=js&"
export * from "./PostSlim.vue?vue&type=script&lang=js&"
import style0 from "./PostSlim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports